export enum StoryPointSender {
  STORY = 0,  
  USER = 1,
  NARRATOR = 2,
  NEWACT = 3
}
